import * as dataConstants from './dataConstants'
import { UsersData, ProductsData, EsimData, PatchOrdersMultisimData, Order, PostOrdersMultisimData } from './dataApi'

/* ------------- Types ------------- */
export interface GetAppDataRequest extends ReturnType<typeof getAppDataRequest> { }
export interface GetAppDataSuccess extends ReturnType<typeof getAppDataSuccess> { }
export interface GetAppDataError extends ReturnType<typeof getAppDataError> { }
export interface PostOrdersMultisim extends ReturnType<typeof postOrdersMultisim> { }
export interface PostOrdersMultisimSuccess extends ReturnType<typeof postOrdersMultisimSuccess> { }
export interface PostOrdersMultisimError extends ReturnType<typeof postOrdersMultisimError> { }
export interface PatchOrdersMultisimOrderId extends ReturnType<typeof patchOrdersMultisimOrderId> { }
export interface PatchOrdersMultisimOrderIdSuccess extends ReturnType<typeof patchOrdersMultisimOrderIdSuccess> { }
export interface PatchOrdersMultisimOrderIdError extends ReturnType<typeof patchOrdersMultisimOrderIdError> { }

export type DataAction =
  | GetAppDataRequest
  | GetAppDataSuccess
  | GetAppDataError
  | PostOrdersMultisim
  | PostOrdersMultisimSuccess
  | PostOrdersMultisimError
  | PatchOrdersMultisimOrderId
  | PatchOrdersMultisimOrderIdSuccess
  | PatchOrdersMultisimOrderIdError

/* ------------- Actions ------------- */
export const getAppDataRequest = () =>
  <const>{
    type: dataConstants.GET_APP_DATA_REQUEST,
  }

export const getAppDataSuccess = (payload: {
  ordersData?: Array<Order>
  usersData: UsersData
  productsData: ProductsData
  esimData: EsimData
}) =>
  <const>{
    type: dataConstants.GET_APP_DATA_SUCCESS,
    ...payload,
  }

export const getAppDataError = (payload: { error: string }) =>
  <const>{
    type: dataConstants.GET_APP_DATA_ERROR,
    ...payload,
  }

/* ------------- Actions ------------- */
export const postOrdersMultisim = () =>
  <const>{
    type: dataConstants.POST_ORDERS_MULTISIM,
  }

export const postOrdersMultisimSuccess = (payload: { data: PostOrdersMultisimData }) =>
  <const>{
    type: dataConstants.POST_ORDERS_MULTISIM_SUCCESS,
    ...payload,
  }

export const postOrdersMultisimError = (payload: { error: string }) =>
  <const>{
    type: dataConstants.POST_ORDERS_MULTISIM_ERROR,
    ...payload,
  }

export const patchOrdersMultisimOrderId = () =>
  <const>{
    type: dataConstants.PATCH_ORDERS_MULTISIM_ORDER_ID,
  }

export const patchOrdersMultisimOrderIdSuccess = (payload: { data: PatchOrdersMultisimData }) =>
  <const>{
    type: dataConstants.PATCH_ORDERS_MULTISIM_ORDER_ID_SUCCESS,
    ...payload,
  }

export const patchOrdersMultisimOrderIdError = (payload: { error: string }) =>
  <const>{
    type: dataConstants.PATCH_ORDERS_MULTISIM_ORDER_ID_ERROR,
    ...payload,
  }
